import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { putEventsFailure, putEventsSuccess } from "../slices/features/postEvents";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* putEventSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.putEvents,
      baseUrl,
      id,
      data
    );

    yield put(putEventsSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(putEventsFailure({ statusCode, statusText }));
  }
}

export function* watchPutEvents() {
  yield takeLatest(RequestTypes.PUT_EVENT_REQUEST, putEventSaga);
}
